<template>
  <div id="contact" class="result" :class="$mq">
    <h1 class="title">{{ title }}</h1>
    <div class="section loader" :class="$mq" v-if="!error">
      <img src="../assets/icons/icon-loader-spin.svg" class="loading" />
    </div>
    <div class="error" v-if="error">{{ $t(`step4.${error}`) }}</div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      error: null,
      loading: false
    };
  },
  computed: {
    ...mapState("calculation", ["simulation", "area", "city"]),
    ...mapState("energy", ["type"]),
    ...mapState("comparison", ["elecProducts", "gasProducts"]),
    title() {
      return this.simulation ? this.$t('Offer.Carousel.title') :  this.$t("comparison.title")
    }
  },
  methods: {
    async getResult() {
      try {
        this.loading = true;
        if (!this.area || !this.city) {
          await this.$store.dispatch("calculation/getCity");
          await this.$store.dispatch("calculation/save");
        }

        await this.$store.dispatch("podium/getPodium");
      } catch (error) {
        console.log(error);
        this.loading = false;
        this.error = "error";
      }

      if (this.simulation) {
        try {
          await this.$store.dispatch("simulation/getSimulation");
          this.$store.dispatch("common/save");
          this.$store.dispatch("contact/save");
          // this.$store.dispatch("simulation/save");
          this.loading = false;
          this.$router.push({ name: "Simulation", query: this.$route.query });
        } catch (error) {
          console.log(error);
          this.loading = false;
          this.error = "error";
        }
      } else {
        try {
          await this.$store.dispatch("comparison/getComparison");
          this.$store.dispatch("common/save");
          this.$store.dispatch("contact/save");
          // this.$store.dispatch("comparison/save");
          this.loading = false;
          this.$router.push({ name: "Comparison", query: this.$route.query });
        } catch (error) {
          this.loading = false;
          if (
            error.data &&
            error.data.error ===
              "no product found for given provider, postal code and customer type"
          )
            this.error = "mono-error";
          else this.error = "error";
        }
      }

      this.$store.commit("middleware/setIsUuid", false);
    }
  },
  created() {
    this.getResult();
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped>
.title {
  margin: 0;
  margin-bottom: 20px!important;
  font-size: 1.7rem!important;
}

.loader {
  margin-top: 150px;
  height: 400px;

  img {
    height: 150px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Process.vue